import BaseService from "./base.service";

export default class GalleryService extends BaseService {
    constructor(ctx) {
        super(ctx)
    }

    getGalleryHome = (query) => {
        return this.get('/gallery/gallery-home', query)
    }
}
